'use client'

import { Cloud, Server, GitBranch, Shield } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function DevOpsCloudPage() {
  return (
    <ServicePageTemplate
      title="DevOps &"
      titleHighlight="Cloud"
      description="Cloud migration, CI/CD pipelines, infrastructure optimization, and deployment automation for modern teams."
      accentColor="from-cyan-500 to-blue-600"
      stats={[
        { value: '100+', label: 'Cloud Migrations' },
        { value: '99.99%', label: 'Uptime SLA' },
        { value: '60%', label: 'Cost Reduction' },
        { value: '10x', label: 'Deploy Speed' }
      ]}
      services={[
        { icon: <Cloud className="w-6 h-6" />, title: 'Cloud Migration', description: 'Seamless migration to cloud with zero downtime.', features: ['AWS, Azure & GCP', 'Hybrid Cloud', 'Data Migration', 'Cost Optimization'] },
        { icon: <GitBranch className="w-6 h-6" />, title: 'CI/CD Pipelines', description: 'Automated build, test, and deploy workflows.', features: ['GitHub Actions', 'Jenkins & ArgoCD', 'Automated Testing', 'Blue-Green Deploys'] },
        { icon: <Server className="w-6 h-6" />, title: 'Infrastructure as Code', description: 'Reproducible infrastructure with Terraform and Ansible.', features: ['Terraform', 'CloudFormation', 'Ansible', 'Auto-Scaling'] },
        { icon: <Shield className="w-6 h-6" />, title: 'Security & Monitoring', description: 'Comprehensive security and observability stack.', features: ['Container Security', 'Log Aggregation', 'APM & Alerting', 'Compliance Auditing'] },
      ]}
      technologies={[
        { name: 'AWS', category: 'Cloud' }, { name: 'Azure', category: 'Cloud' },
        { name: 'Docker', category: 'Container' }, { name: 'Kubernetes', category: 'Orchestration' },
        { name: 'Terraform', category: 'IaC' }, { name: 'Jenkins', category: 'CI/CD' },
        { name: 'Prometheus', category: 'Monitoring' }, { name: 'Grafana', category: 'Observability' },
      ]}
      process={[
        { step: '01', title: 'Infrastructure Audit', description: 'Assess current infrastructure and identify improvements.' },
        { step: '02', title: 'Architecture Design', description: 'Design scalable, resilient cloud architecture.' },
        { step: '03', title: 'Migration Planning', description: 'Create phased migration strategy with rollback plans.' },
        { step: '04', title: 'Implementation', description: 'Build infrastructure, pipelines, and automation.' },
        { step: '05', title: 'Optimization', description: 'Performance tuning and cost optimization.' },
        { step: '06', title: 'Managed Services', description: 'Ongoing monitoring, patching, and support.' },
      ]}
    />
  )
}
